<template>
    <div>
        <div v-if="currentState == 3">
            <loading></loading>
            <modal type="error">
                <template v-slot:message>
                    Something went wrong.
                </template>
            </modal>
        </div>

        <div v-if="currentState == 1 && !question">
            <loading>Loading...</loading>
        </div>

        <div v-if="currentState == 1 && question">

            <section class="fullscreen game">
                <div class="container container-lg game__inner">
                    <div class="game__header mt--10">
                        <div class="game__info mb--md">
                            <div :class="['game__player', 'game__player--first', 'animated', 'bounceInLeft', preferences.profileColor]">
                                <div class="game__player__inner">
                                    <div class="game__player__avatar">
                                        <img :src="avatar" alt="" />
                                        <span class="active"></span>
                                    </div>

                                    <div>
                                        <div class="game__player__name game__player__name--max-width">{{ user.nick }}</div>

                                        <div class="game__player__score">{{ totalPoints }}</div>
                                    </div>

                                </div>
                            </div>

                            <div class="game__progress animated bounceInDown">
                                <div :class="['game__progress__time', {'game__progress__time--active': timerActive}]" v-if="beforeGameCounterReady">
                                    <countdown @hook:mounted="countdownReady = true" ref="countdownTimer" :speed="100"
                                               :left-time="20000" @process="(vac) => timeLeft(vac)" @finish="() => handleCountdownEnd()">
                                        <div id="countdown-number" slot-scope="{ timeObj }"
                                             class="game__progress__time game__progress__time--active">
                                            <span v-if="`${timeObj.leftTime}` < 10">0</span>
                                            <span v-else>{{ leftTimeSec }}</span>
                                        </div>
                                    </countdown>
                                    <svg>
                                        <circle r="16" cx="19" cy="19" v-bind:style="timerStyle"></circle>
                                    </svg>
                                </div>

                                <div class="game__progress__title">LVL {{ level }} • {{ questionIndex + 1 }}.</div>
                            </div>

                            <div :class="['game__player', 'game__player--last', 'animated', 'bounceInLeft', preferences.profileColor]">
                                <div class="game__player__inner">
                                    <div class="game__player__avatar">
                                        <img :src="avatar" alt="" />
                                    </div>

                                    <div>
                                        <div class="game__player__name game__player__name--max-width">{{ user.nick }}</div>

                                        <div class="game__player__score">{{ highestPoints }}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="game__body panel bg--layer-light text--center mb--md animated bounceInUp" v-if="!beforeGameCounterReady">
                        <div class="game__body__inner">
                            <div class="game__question">
                                <div v-if="(beforeGameCounterValue -1) > 0" class="game__success game__success--animate">
                                    <strong>{{ beforeGameCounterValue - 1 }}</strong>
                                </div>
                                <div class="game__success game__success--animate" v-else><strong>GO!</strong></div>
                            </div>
                        </div>
                    </div>

                    <div v-if="goodAnswersInARow > 0 && showMessage" class="game__body bg--layer-light text--center mb--md">
                        <div class="game__body__inner">
                            <div v-if="goodAnswersInARow > 5" class="game__success game__success--animate">
                                <strong>Amazing!</strong> {{ goodAnswersInARow }} in a row
                            </div>

                            <div v-if="goodAnswersInARow === 5" class="game__success game__success--animate">
                                <strong>Excellent!</strong> 5 in a row
                            </div>

                            <div v-if="goodAnswersInARow === 4" class="game__success game__success--animate">
                                <strong>Excellent!</strong> 4 in a row
                            </div>

                            <div v-if="goodAnswersInARow === 3" class="game__success game__success--animate">
                                <strong>Great!</strong> 3 in a row
                            </div>

                            <div v-if="goodAnswersInARow === 2" class="game__success game__success--animate">
                                <strong>Great!</strong> 2 in a row
                            </div>

                            <div v-if="goodAnswersInARow === 1" class="game__success game__success--animate">
                                <strong>Good job!</strong>
                            </div>
                        </div>
                    </div>

                    <div class="game__body panel bg--layer-light text--center mb--md" v-if="beforeGameCounterReady && !showMessage">
                        <div class="game__body__inner">
                            <h4 class="text--xs opacity--md mb--sm">{{ question.group }}</h4>

                            <div :class="{'game__question': true, 'game__question--long': (question && question.question.length > 40) }">{{ question.question }}</div>
                        </div>
                    </div>

                    <form class="row game__footer mb--0" v-if="beforeGameCounterReady">

                        <div class="col-12 col-lg-6" v-for="answer in question.answers">
                            <button type="button" @click="sendAnswer(answer)"
                                    :disabled="answered && answered !== answer.id && answer.id !== correctAnswer"
                                    :class="{'btn': true, 'btn--action': true, 'mb--sm': true, 'btn--white': (!answered || (answered !== answer.id && correctAnswer !== answer.id)), 'btn--green': answered && ((answered == answer.id && answerIsCorrect) || correctAnswer === answer.id), 'btn--select': answered && answered == answer.id && answer.id !== correctAnswer}">
                                {{ answer.answer }}
                                <div class="btn--action__icon btn--action__icon--left"
                                     v-if="answered && answered == answer.id">
                                    <img :src="avatar" alt="" />
                                </div>
                            </button>
                        </div>

                    </form>
                </div>
            </section>
        </div>

        <div v-if="currentState == 2">
            <section class="fullscreen game">
                <div class="container container-lg game__inner">
                    <div class="game__header mt--10">
                        <div class="game__info mb--md">

                            <div :class="['game__player', 'game__player--first', preferences.profileColor]">
                                <div class="game__player__inner">
                                    <div class="game__player__avatar">
                                        <img :src="avatar" alt="" />
                                        <span class="active"></span>
                                    </div>

                                    <div>
                                        <div class="game__player__name game__player__name--max-width">{{ user.nick }}</div>

                                        <div class="game__player__score">{{ totalPoints }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="game__progress">
                                <div class="game__progress__title">Level {{ level }}</div>
                            </div>

                                <div :class="['game__player', 'game__player--last', preferences.profileColor]">
                                <div class="game__player__inner">
                                    <div class="game__player__avatar">
                                        <img :src="avatar" alt="" />
                                        <span class="active"></span>
                                    </div>

                                    <div>
                                        <div class="game__player__name game__player__name--max-width">{{ user.nick }}</div>

                                        <div class="game__player__score">{{ highestPoints }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="game__body panel bg--layer-light text--center mb--md">
                        <div class="game__body__inner">
                            <div class="game__question">
                                Game finished. You answered {{ questionIndex }} question<span v-if="questionIndex > 1">s</span> correctly.

                                <p v-if="highestPoints < totalPoints">
                                    Congratulations, you have beaten your previous best!
                                </p>
                            </div>
                        </div>
                    </div>

                    <form class="game__footer mb--0">
                        <button type="button" @click="restart" class="btn btn--action btn--primary mb--sm">Start new game</button>
                        <router-link to="/" class="btn btn--action btn--white mb--sm">Go to Dashboard</router-link>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import api from '../../api/singleplayer';
    import { mapState, mapGetters } from 'vuex'

    export default {
        data: function () {
            return {
                currentState: 1,
                quiz: null,
                level: 1,
                question: null,
                answered: false,
                answerIsCorrect: null,
                correctAnswer: null,
                leftTime: 20000,
                leftTimeSec: 20,
                questionIndex: 0,
                totalPoints: 0,
                highestPoints: null,
                countdownReady: false,
                timerActive: true,
                waitBeforeNextAction: 2000,
                goodAnswersInARow: 0,
                showMessage: false,
                beforeGameCounterReady: false,
                beforeGameCounterValue: 4,
            }
        },

        computed: {
            ...mapState('auth', [
                'user'
            ]),

            ...mapGetters('auth', [
                'avatar',
                'preferences'
            ]),

            timerStyle() {
                let strokeLength = 16 * Math.PI * 2;

                if (this.leftTime < 5000) {
                    return {
                        stroke: '#D95656',
                        strokeDashoffset: strokeLength - (strokeLength / 20 * (Math.ceil(this.leftTime / 1000))) + 'px',
                        strokeDasharray: strokeLength + 'px',
                    }
                }

                return {
                    strokeDashoffset: strokeLength - (strokeLength / 20 * (Math.ceil(this.leftTime / 1000))) + 'px',
                    strokeDasharray: strokeLength + 'px',
                }
            }
        },

        methods: {
            async createGame() {
                try {
                    const response = await api.create()
                    this.quiz = response.data.data
                } catch (e) {
                    Quiz.$emit('single-player-game-create-error')
                }
            },

            timeLeft(props) {
                this.leftTime = props.timeObj.leftTime
                this.leftTimeSec = props.timeObj.ceil.s
            },
            
            restart() {
                this.quiz = null
                this.question = null
                this.currentState = 1
                this.answerIsCorrect = null
                this.correctAnswer = null
                this.answered = false
                this.goodAnswersInARow = 0
                this.level = this.user.level
                this.questionIndex = 0
                this.totalPoints = 0
                this.timerActive = true
                this.beforeGameCounterReady = false
                this.beforeGameCounterValue = 4
                this.start()
            },

            handleCountdownEnd() {
                if (this.answered) {
                    return;
                }

                this.timerActive = false
                this.goodAnswersInARow = 0

                this.answered = -1
                this.currentState = 2

                this.close();
            },

            closeGame() {
                this.close();
                this.$router.push('/')
            },

            sendAnswer(answer) {
                if (this.answered) {
                    return false
                }

                this.answered = answer.id
                this.$refs.countdownTimer.stopCountdown()
                this.timerActive = false

                api.answer({
                    answer: answer,
                    question: this.question,
                    quiz: this.quiz,
                    leftTime: this.leftTime
                }).then((response) => {
                    this.answerIsCorrect = response.data.isSuccess

                    if (this.answerIsCorrect) {
                        ++this.goodAnswersInARow
                        this.showMessage = true
                    }

                    this.correctAnswer = response.data.correctAnswer
                    this.totalPoints += response.data.points

                    this.sleep(3000).then(() => {
                        if (!response.data.isSuccess) {
                            this.currentState = 2
                            this.showMessage = false
                            this.close();

                            return;
                        }

                        api.getQuestion(this.quiz).then((response) => {
                            this.showMessage = false
                            ++this.questionIndex
                            this.answerIsCorrect = null
                            this.answered = null
                            this.level = response.data.data.level
                            this.question = response.data.data
                        })

                        this.startTimer()
                    })
                }).catch((error) => this.currentState = 3)
            },

            start() {
                this.timerActive = true
                this.getSinglePlayerRecord();

                this.createGame().then(() => {

                    if (! this.quiz) {
                        this.currentState = 3
                    }

                    api.getQuestion(this.quiz).then((res) => {
                        this.question = res.data.data

                        if (! this.beforeGameCounterReady) {
                            let counter = setInterval(() => {
                                if (this.beforeGameCounterValue > 0) {
                                    --this.beforeGameCounterValue
                                }

                                if (this.beforeGameCounterValue === 0) {
                                    clearInterval(counter)
                                    this.beforeGameCounterReady = true
                                    this.question = res.data.data
                                }
                            }, 1000)
                        }
                    })
                })
            },

            startTimer() {
                this.timerActive = true
                this.leftTime = 20 * 1000
                if (this.countdownReady) {
                    this.$refs.countdownTimer.startCountdown(true)
                }
            },

            async close() {
                try {
                    await api.close(this.quiz)
                } catch (error) {
                    Quiz.$emit('single-player-close-error', error)
                }
            },

            async getSinglePlayerRecord() {
                try {
                    await api.record().then((res) => {
                        this.highestPoints = res.data.highestPoints;
                    })
                } catch (error) {
                    Quiz.$emit('single-player-record-error', error)
                }
            }
        },

        watch: {
            currentState: function (step) {
                if (step === 2) {
                    $('html').removeClass('mobile-fixed-screen')
                } else {
                    $('html').addClass('mobile-fixed-screen')
                }
            }
        },

        created() {
            this.level = this.user.level
            this.getSinglePlayerRecord();
            this.start()
        }
    }
</script>
